import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import Styles from "../../../Styles.module.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import clsx from "clsx";
import { isMobileDevice } from "../../../utils/AppUtils";

function MoveIntoHomeSteps({ steps, xlUp }) {
  return (
    <React.Fragment>
      {steps.map((data, index) => {
        return (
          <Grid
            item
            xs={2}
            container
            key={index}
            justifyContent="center"
            style={{
              height: isMobileDevice() ? "100%" : "90%",
              minWidth: isMobileDevice() ? "40%" : "20%",
            }}
          >
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              style={{
                height:
                  (index === steps.length - 1) & !xlUp
                    ? "74%"
                    : (index === steps.length - 1) & xlUp
                    ? "76%"
                    : "40%",
                marginTop: index === steps.length - 1 ? "-16%" : 0,
              }}
            >
              <img
                src={data.image}
                alt={data.name}
                title={data.name}
                style={{
                  width: isMobileDevice() ? "70%" : "85%",
                  height:
                    index === steps.length - 1 && isMobileDevice() && "91%",
                }}
              />
            </Grid>
            {index !== steps.length - 1 && (
              <Grid item xs={12} style={{ height: "15%", textAlign: "center" }}>
                <Typography
                  className={Styles.navyBlueColor}
                  style={{ fontSize: xlUp ? 12 : 8 }}
                >
                  {data.description}
                </Typography>
              </Grid>
            )}
            <Grid
              container
              item
              xs={4}
              md={3}
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              style={{
                backgroundColor: "#F5F6F8",
                height: isMobileDevice() ? 40 : xlUp ? 48 : 32,
                width: isMobileDevice() ? 40 : xlUp ? 42 : 32,
                borderRadius: "50%",
                textAlign: "center",
                padding: 16,
              }}
            >
              <Typography
                className={clsx(Styles.navyBlueColor, Styles.font14)}
                style={{ fontWeight: 500 }}
              >
                {index === steps.length - 1 ? "FIN" : index + 1}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
    </React.Fragment>
  );
}

export default function MoveIntoHomeJourney({
  xlUp,
  setShowMoveIntoHomeJourney,
  setShowFullJourney,
}) {
  const steps = [
    {
      description: "Compare and connect with home renovators",
      image: "/app/images/move-into-home-step1.svg",
    },
    {
      description: "Review contract and finalize home renovations",
      image: "/app/images/move-into-home-step2.svg",
    },
    {
      description: "Get settled in your new home",
      image: "/app/images/move-into-home-step3.svg",
    },
    {
      description: "Learn more about home warranty and maintenance",
      image: "/app/images/move-into-home-step4.svg",
    },
    {
      description: "",
      image: "/app/images/move-into-home-step5.svg",
    },
  ];
  return (
    <Grid
      container
      spacing={!isMobileDevice() && 4}
      style={{
        // height: xlUp ? "20.75rem" : "18.5rem",
        height: isMobileDevice() ? 251 : xlUp ? "18.5rem" : 282,
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          padding: isMobileDevice() ? 0 : "10px 0px 0px 20px",
          height: isMobileDevice() ? 0 : xlUp ? "12%" : "15%",
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon />}
          style={{
            textTransform: "capitalize",
            color: "#D90368",
          }}
          onClick={() => {
            setShowMoveIntoHomeJourney(false);
            setShowFullJourney(true);
          }}
        >
          Move Into Your Home
        </Button>
      </Grid>
      {isMobileDevice() ? (
        <Grid
          container
          item
          xs={12}
          style={
            isMobileDevice()
              ? {
                  display: "flex",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }
              : {}
          }
        >
          <MoveIntoHomeSteps steps={steps} xlUp={xlUp} />
        </Grid>
      ) : (
        <MoveIntoHomeSteps steps={steps} xlUp={xlUp} />
      )}
    </Grid>
  );
}
